import { render, staticRenderFns } from "./avatarChart.vue?vue&type=template&id=d318b3d6&scoped=true"
import script from "./avatarChart.vue?vue&type=script&lang=js"
export * from "./avatarChart.vue?vue&type=script&lang=js"
import style0 from "./avatarChart.vue?vue&type=style&index=0&id=d318b3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d318b3d6",
  null
  
)

export default component.exports